import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { AdminService } from '@shared-angular/services/admin.service';
import { ProjectService } from '../services/project.service';

export const archiveResolver: ResolveFn<ChatbotConfig[]> = async () => {
  const adminService = inject(AdminService);
  const prs = inject(ProjectService);
  prs.selectedProject = undefined;
  return await adminService.loadArchiveBots();
};
